import styled, { css } from "styled-components";
const Title = styled.p(
  ({ theme }) => css`
    color: ${theme.colors.text.primary};
    margin-bottom: 15px;
  `
);
export default Title;
